"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _user = require("@/api/iot/user");
var _default = {
  props: ['editItem', 'batteryTypeList'],
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        id: 0,
        battery_type_id: 0,
        end_time: '',
        can_use_times: 0,
        add_days: 0,
        add_hours: 0
      },
      rules: {
        battery_type_id: [{
          required: true,
          message: '请选择电池类型',
          trigger: 'change'
        }],
        can_use_times: [{
          required: true,
          message: '请输入剩余次数',
          trigger: 'change'
        }, {
          type: 'number',
          min: 0,
          message: '剩余次数不能小于0',
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            for (var key in _this.form) {
              if (_this.editItem[key]) {
                _this.form[key] = _this.editItem[key];
              }
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  methods: {
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          (0, _user.changeRent)((0, _objectSpread2.default)({}, _this2.form)).then(function (res) {
            _this2.$emit('getList');
            _this2.dialogVisible = false;
          });
        } else {
          _this2.$message({
            message: '请检查表单错误',
            type: 'error'
          });
          return false;
        }
      });
    }
  }
};
exports.default = _default;